import React, {ReactNode} from 'react';

interface TableColumnProps {
    caption: string | Date;
    dataField: string;
    filterType?: number,
    renderCell?: (value: any, row: any) => ReactNode;
    style?: React.CSSProperties;
}

const TableColumn: React.FC<TableColumnProps> = ({ caption }) => {
    return <>{caption}</>;
};

export default TableColumn;